import '../styles/EditStudentInfoDialog.css'
import closeIcon from '../images/close-icon.svg'
import { useCookies } from 'react-cookie'
import { useFetch } from '../hooks/useFetch';
import { useState, useEffect, useRef } from 'react';
import { StudentInfomation } from './StudentInfo';
import { useParams } from 'react-router-dom';
import {  MenuItem, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePickerInput from './DatePickerInput';
import moment from 'moment';
import axios from 'axios';
import EditStudentSkeleton from './EditStudentSkeleton';
import LinearProgressBar from './LinearProgressBar';
import SnackbarAlert from './SnackbarAlert';

interface EditStudentInfoDialogProps {
    setOpenEditInfo: (value: boolean) => void;
}

interface StudentStatus {
    id: number,
    status: string
}


export default function EditStudentInfoDialog({ setOpenEditInfo }: EditStudentInfoDialogProps) {

    const [cookies] = useCookies(['user'])
    const { studentID: id } = useParams()

    const { data: getStudentStatusData, loading: getStudentStatusLoading, error: getStudentStatusError } = useFetch({
        url: '/StudentStatuses',
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${cookies?.user?.token}`
        }
    })

    const { data: getStudentData, loading: getStudentLoading, error: getStudentError } = useFetch({
        url: `/Students/${id}`,
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${cookies?.user?.token}`
        }
    })

    const [statusList, setStatusList] = useState<StudentStatus[]>([])
    const [studentInfomation, setStudentInfomation] = useState<StudentInfomation>()
    const [proposalDate, setProposalDate] = useState<null | moment.Moment>(null)
    const [facultyMembers, setFacultyMembers] = useState<string[]>([])

    const [snackbarMessage, setSnackbarMessage] = useState<null | {
        message: string,
        severity?: 'success' | 'info' | 'warning' | 'error',
        autoHideDuration?: number | null
    }>(null)

    useEffect(() => {
        if (getStudentStatusData) {
            setStatusList(getStudentStatusData)
        }
    }, [getStudentStatusData])

    useEffect(() => {
        if (getStudentData) {
            setStudentInfomation(getStudentData)
            setStudentStatusId(getStudentData.studentStatusId)
            if(getStudentData.proposalDate) setProposalDate(moment(getStudentData.proposalDate))
        }
    }, [getStudentData])

    const [formLoading, setFormLoading] = useState<boolean>(false)
    let loading = getStudentStatusLoading || getStudentLoading || formLoading

    const [studentStatusId, setStudentStatusId] = useState<number>(0)
    const mobileRef = useRef<HTMLInputElement>(null);
    const emailRef = useRef<HTMLInputElement>(null);
    const lineIdRef = useRef<HTMLInputElement>(null);
    const noteRef = useRef<HTMLInputElement>(null);
    const advisorRef = useRef<HTMLInputElement>(null);
    const advisorOfficeRef = useRef<HTMLInputElement>(null);
    const coAdvisorRef = useRef<HTMLInputElement>(null);

    const onAdvisorChange = (value: string | null) => {
        if (value) {
            axios.get(`/Faculties?term=${value}`, {
                headers: {
                    'Authorization': `Bearer ${cookies?.user?.token}`
                },
            }).then((res) => {
                setFacultyMembers(res.data)
            }).catch((err) => {
                setFacultyMembers([])
            })   
        } else {
            setFacultyMembers([])
        }
    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setFormLoading(true)
        setSnackbarMessage(null)
        const data = {
            studentStatusId: studentStatusId,
            email: emailRef.current?.value || null,
            mobile: mobileRef.current?.value || null,
            lineId: lineIdRef.current?.value || null,
            note: noteRef.current?.value || null,
            advisor: advisorRef.current?.value || null,
            advisorOffice: advisorOfficeRef.current?.value || null,
            coAdvisor: coAdvisorRef.current?.value || null,
            proposalDate: proposalDate?.format('YYYY-MM-DD') || null,
        }

        axios.put(`/Students/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${cookies?.user?.token}`
            },
            withCredentials: true
        }).then((res) => {
            setSnackbarMessage({
                message: 'Student information updated successfully!',
                severity: 'success',
                autoHideDuration: 1500
            })
            setTimeout(() => {
                setFormLoading(false)
                setOpenEditInfo(false)
            }, 2000)
        }).catch((err) => {
            setSnackbarMessage({
                message: 'Something went wrong! Please try again later.',
                severity: 'error',
                autoHideDuration: 3000
            })
            setFormLoading(false)
        })
    }


    return (
        <div className="EditStudentInfoDialog">
            <div className="EditStudentInfoDialog-dialog">
                <button className="ProgressDialog-close-button" onClick={() => setOpenEditInfo(false)}>
                    <img src={closeIcon} width={24} height={24} alt="close-icon" />
                </button>
                {
                    (formLoading || loading) &&
                    <div className="ProgressDialog-linear-progress">
                        <LinearProgressBar />    
                    </div>
                }
                <div className="EditStudentInfoDialog-header">
                    <h4>Edit Student Information</h4>
                </div>
                {studentInfomation ? (
                    <>
                        <div className="EditStudentInfoDialog-student-container flex-column gap-dot75">
                            <h4 className="EditStudentInfoDialog-name">{studentInfomation?.title} {studentInfomation?.firstName} {studentInfomation?.lastName}</h4>
                            <h4 className="EditStudentInfoDialog-id">{id}</h4>
                        </div>

                        <div className="EditStudentInfoDialog-form-container">
                            <form className='flex-column gap1' onSubmit={handleSubmit}>
                                <div className='flex gap-dot5'>
                                    <TextField id="select" label="สถานะ" value={studentStatusId} onChange={(e) => setStudentStatusId(Number(e.target.value))} variant="outlined" disabled={loading} select fullWidth required>
                                        {statusList.map((status) => (
                                            <MenuItem key={status.id} value={status.id}>{status.status}</MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField label="เบอร์โทร" variant="outlined" inputRef={mobileRef} type="number" InputProps={{ inputProps: { min: 0 } }} defaultValue={(studentInfomation.mobile || '').replace('-', '').trim()} disabled={loading} fullWidth />
                                </div>

                                <div className='flex gap-dot5'>
                                    <TextField label="อีเมล" variant="outlined" inputRef={emailRef} type="email" defaultValue={studentInfomation.email} disabled={loading} fullWidth />
                                    <TextField label="LINE ID" variant="outlined" inputRef={lineIdRef} defaultValue={studentInfomation.lineId} disabled={loading} fullWidth />
                                </div>
                                <div className='flex gap-dot5'>
                                    <Autocomplete
                                        freeSolo
                                        options={facultyMembers.map((option) => option)}
                                        fullWidth
                                        defaultValue={studentInfomation.advisor}
                                        disabled={loading}
                                        disableClearable={true}
                                        onInputChange={(e, value) => onAdvisorChange(value)}
                                        renderInput={(params) => (
                                            <TextField {...params} label="อาจารย์ที่ปรึกษาหลัก" variant="outlined" inputRef={advisorRef} fullWidth/>
                                        )}
                                    />
                                    <TextField label="สังกัด" variant="outlined" inputRef={advisorOfficeRef} defaultValue={studentInfomation.advisorOffice} disabled={loading} fullWidth />
                                </div>
                                <div className='flex gap-dot5'>
                                    <TextField label="อาจารย์ที่ปรึกษาร่วม" variant="outlined" inputRef={coAdvisorRef} defaultValue={studentInfomation.coAdvisor} disabled={loading} fullWidth />
                                    <DatePickerInput
                                        label="Proposal Date"
                                        emptyLabel=''
                                        inputVariant='outlined'
                                        selectedDate={proposalDate}
                                        setSelectedDate={setProposalDate}
                                        disabled={loading}
                                        clearable={true}
                                    />
                                </div>

                                <TextField label="หมายเหตุ" variant="outlined" inputRef={noteRef} defaultValue={studentInfomation.note} disabled={loading} fullWidth multiline />
                                <div className="ProgressDialog-bottom-container" >
                                    <div className="ProgressDialog-actions" style={{ marginLeft: 'auto' }}>
                                        <button className="ProgressDialog-button" onClick={() => setOpenEditInfo(false)}>Cancel</button>
                                        <button className="ProgressDialog-button" type="submit" disabled={formLoading}>Save</button>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </>
                ) : (
                    <EditStudentSkeleton />
                )
                }
            </div>
            {
                (snackbarMessage) &&
                <SnackbarAlert severity={snackbarMessage.severity} message={snackbarMessage.message} />
            }
        </div>


    )
}